"use client";

import React from "react";
import { Input } from "@/components/ui/input";
import { Clock } from "lucide-react";
import type { SimpleFieldConfig } from "../../../types/index";

interface TimeFilterInputProps {
  fieldId: string;
  fieldConfig: SimpleFieldConfig;
  currentFilter?: { type: string; value: any };
  addAdvancedFilter: (fieldId: string, filterType: string, value: any) => void;
}

export function TimeFilterInput({
  fieldId,
  fieldConfig,
  currentFilter,
  addAdvancedFilter,
}: TimeFilterInputProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Clock className="h-4 w-4 text-gray-400" />
        <Input
          type="time"
          placeholder="From"
          value={currentFilter?.value?.min || ""}
          onChange={(e) =>
            addAdvancedFilter(fieldId, "timeRange", {
              min: e.target.value,
              max: currentFilter?.value?.max,
            })
          }
          className="flex-1"
        />
      </div>
      <div className="flex items-center gap-2">
        <Clock className="h-4 w-4 text-gray-400" />
        <Input
          type="time"
          placeholder="To"
          value={currentFilter?.value?.max || ""}
          onChange={(e) =>
            addAdvancedFilter(fieldId, "timeRange", {
              min: currentFilter?.value?.min,
              max: e.target.value,
            })
          }
          className="flex-1"
        />
      </div>
    </div>
  );
}
